import { useEffect, useState } from "react";

import { useTranslation } from "_metronic/i18n/language";
import store from "app/store/store";
import { titlePage } from "utils/titlepage";
import { UserService, UserApiService } from "app/services";
import { UserType } from "interfaces";

type AccountModelProps = {
  userService: UserService;
};

export const useAccountModel = ({ userService }: AccountModelProps) => {
  const [accounts, setAccounts] = useState<unknown[]>([]);
  const [users, setUsers] = useState<UserType[]>([]);

  const translate: (key: string) => string = useTranslation();
  const titleP = translate("screenApp.listPacient.account.titleList");
  const { auth } = store.getState();
  const endPoint = `/account/searchbyuserid?FilterInt=${auth.user.id}`;

  useEffect(() => {
    titlePage(`${titleP} - ${translate("labels_admin")}`);
  }, []);

  useEffect(() => {
    getUserAll();
  }, []);

  const headRows = [
    { label: translate("screens.dashboard.action") },
    { column: "Name", label: translate("screens.user.list.name") },
    { column: "Cpf", label: translate("screens.user.list.document") },
    { column: "Email", label: translate("screens.user.list.email") },
    { column: "UserId", label: translate("screens.user.list.user") },
    {
      column: "registrationDate",
      label: translate("screens.user.list.created"),
    },
  ];

  const getUserAll = async (): Promise<void> => {
    if (!UserApiService.total) {
      const total = await userService.getTotal();
      UserApiService.total = total;
    }
    const { data } = await userService.get();
    setUsers(data);
  };

  const searchUserById = (id: number): string => {
    const filterUser = users?.find(value => value.id === id);
    return filterUser?.nome ?? "";
  };

  const handleChangeAccounts = (accounts: Array<unknown>): void => {
    setAccounts(accounts);
  };

  if (!auth?.user?.id) {
    throw new Error("User ID is required to fetch user data");
  }

  return {
    searchUserById,
    translate,
    handleChangeAccounts,
    accounts,
    headRows,
    endpoint: endPoint,
  };
};
